import LinkIcon from '@mui/icons-material/LinkOutlined';
import LinkOffIcon from '@mui/icons-material/LinkOffOutlined';
import { ToggleButton, ToggleButtonProps } from '@mui/material';
import React, { FormEvent } from 'react';
import { useSlate } from 'slate-react';
import { isLinkActive, isUrl } from '../../helpers';
import { insertLink, unwrapLink } from '../../transformers';
import { notify } from "../../../../../shared/utils/notify";

// Link element insertion button
export const LinkButton = ({ value = 'link', ...props }: ToggleButtonProps) => {
	const editor = useSlate();

	const handleMouseDown = (event: FormEvent<HTMLButtonElement>) => {
		event.preventDefault();
		if (isLinkActive(editor)) {
			unwrapLink(editor);
			return;
		}

		const url = window.prompt('Gib die URL des Links ein:');
		if (!url || !isUrl(url)) {
			notify('URL ist ungltig.');
			return;
		}

		insertLink(editor, url);
	};

	return (
		<ToggleButton
			size='small'
			value={value}
			selected={isLinkActive(editor)}
			onMouseDown={handleMouseDown}
			{...props}
		>
			{isLinkActive(editor) ? <LinkOffIcon /> : <LinkIcon />}
		</ToggleButton>
	);
};
